export default __webpack_public_path__ + "media/images/banners/bnr_tohoku-19f3981d7fcbb77a3e2e3f9c041b3fb3.png";